import { Component, Input } from '@angular/core';
import { VoucherAllocationResultDto } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-voucher-allocation-card',
  standalone: false,
  templateUrl: './voucher-allocation-card.component.html',
  styles: `
    .voucher-allocation-card {
      transition:
        transform 0.15s ease,
        border-color 0.15s ease;
    }
    .voucher-allocation-card:hover {
      transform: scale(1.02);
      border-color: var(--bs-primary) !important;
    }
  `,
})
export class VoucherAllocationCardComponent {
  @Input() allocation!: VoucherAllocationResultDto;
  @Input() includeHoverEffects = true;

  get statusClass(): string {
    switch (this.allocation?.distributionCycle?.statusString) {
      case 'Active':
        return 'badge-success border border-success';
      case 'NotStarted':
        return 'badge-warning border border-warning text-dark';
      default:
        return 'badge-secondary border border-secondary';
    }
  }

  get creditsIssuedPct(): number {
    return this.allocation.allocatedAmount > 0
      ? Math.min(100, (this.allocation.creditsIssuedAmount / this.allocation.allocatedAmount) * 100)
      : 0;
  }

  get redeemedPct(): number {
    return this.allocation.allocatedAmount > 0
      ? Math.min(100, (this.allocation.redeemedAmount / this.allocation.allocatedAmount) * 100)
      : 0;
  }
}
